import React from "react";
import { Menu, NavMenu, NavMenuItem, NavMenuBody } from "@weezevent/nacre";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { CAPACITIES } from "../../constants/capacities";
import SolutionControlMenu from "../solution-control-menu";
import PropTypes from "prop-types";
import { useAllUserCapacities } from "../../utils/rights";

export function MenuOrga({ organizationId, isLevelEvent = false }) {
	const { t } = useTranslation();
	const history = useHistory();
	const path = `/access/O${organizationId}`;
	const userCapacities = useAllUserCapacities(organizationId);

	return (
		<>
			<Menu
				useNew
				alternative
				history={history}
				capacities={userCapacities}
			>
				<NavMenu>
					<NavMenuItem
						icon="calendar-star"
						to={`${path}/events`}
						allowedCapacities={[
							CAPACITIES.EVENT_CONFIG.READ,
							CAPACITIES.EVENT_CONFIG.MANAGE,
							CAPACITIES.ATTENDEES.RO,
							CAPACITIES.ATTENDEES.MANAGE,
							CAPACITIES.ZONE.READ,
							CAPACITIES.ZONE.MANAGE,
							CAPACITIES.POPULATION.READ,
							CAPACITIES.POPULATION.MANAGE
						]}
					>
						<Trans i18nKey={"access.menus.events"} />
					</NavMenuItem>
				</NavMenu>
				<NavMenu>
					<NavMenuItem
						icon="list"
						to={`${path}/checkpoints`}
						allowedCapacities={[
							CAPACITIES.DEFAULT.ADMIN,
							CAPACITIES.DEFAULT.OWNER,
							CAPACITIES.CHECKLIST.READ,
							CAPACITIES.CHECKLIST.EDIT
						]}
					>
						<Trans i18nKey={"access.checkpoint.checkpointPlural"} />
					</NavMenuItem>
				</NavMenu>
				<NavMenu>
					<NavMenuItem
						icon="group"
						to={`${path}/attendees`}
						allowedCapacities={[
							CAPACITIES.ATTENDEES.MANAGE,
							CAPACITIES.ATTENDEES.RO
						]}
					>
						<Trans i18nKey={"access.menus.attendees"} />
					</NavMenuItem>
				</NavMenu>
				<NavMenu>
					<NavMenuItem
						icon="user"
						to={`${path}/partners`}
						allowedCapacities={[
							CAPACITIES.DEFAULT.ADMIN,
							CAPACITIES.DEFAULT.OWNER
						]}
					>
						<Trans i18nKey={"access.menus.partners"} />
					</NavMenuItem>
				</NavMenu>
				<NavMenu>
					<NavMenuItem
						icon="chart"
						allowedCapacities={[
							CAPACITIES.SCANS_STATS.READ,
							CAPACITIES.DEFAULT.ADMIN,
							CAPACITIES.DEFAULT.OWNER
						]}
					>
						<Trans i18nKey={"access.menus.statistics"} />
					</NavMenuItem>
					<NavMenuBody>
						<NavMenuItem
							to={`${path}/exploitation/scans-statistics`}
							allowedCapacities={[CAPACITIES.SCANS_STATS.READ]}
						>
							<Trans i18nKey={"access.menus.scansStatistics"} />
						</NavMenuItem>
						<NavMenuItem
							to={`${path}/exploitation/report`}
							allowedCapacities={[
								CAPACITIES.DEFAULT.ADMIN,
								CAPACITIES.DEFAULT.OWNER
							]}
						>
							<Trans i18nKey={"access.menus.exportStatistics"} />
						</NavMenuItem>
					</NavMenuBody>
					<NavMenuItem icon="file" to={`${path}/reports`}>
						<Trans i18nKey={"access.menus.reports"} />
					</NavMenuItem>
				</NavMenu>
				<NavMenu
					allowedCapacities={[
						CAPACITIES.DEVICE_STATUS.MANAGE,
						CAPACITIES.DEVICE_STATUS.READ,
						CAPACITIES.TEMPLATE.MANAGE,
						CAPACITIES.TEMPLATE.RO
					]}
				>
					<NavMenuItem icon="mobile">
						<Trans i18nKey={"access.menus.devices"} />
					</NavMenuItem>
					<NavMenuBody>
						<NavMenuItem
							to={`${path}/custom-screens/templates`}
							allowedCapacities={[
								CAPACITIES.TEMPLATE.MANAGE,
								CAPACITIES.TEMPLATE.RO
							]}
							activeTab={0}
						>
							<Trans i18nKey={"access.menus.customScreens"} />
						</NavMenuItem>
						<NavMenuItem
							to={`${path}/custom-screens/mappings`}
							allowedCapacities={[
								CAPACITIES.TEMPLATE.MANAGE,
								CAPACITIES.TEMPLATE.RO
							]}
						>
							<Trans i18nKey={"access.menus.mappings"} />
						</NavMenuItem>
						<NavMenuItem
							to={`${path}/device-status`}
							allowedCapacities={[
								CAPACITIES.DEVICE_STATUS.MANAGE,
								CAPACITIES.DEVICE_STATUS.READ
							]}
						>
							<Trans i18nKey={"access.menus.deviceStatus"} />
						</NavMenuItem>
					</NavMenuBody>
				</NavMenu>
				<NavMenu allowedCapacities={userCapacities}>
					<NavMenuItem
						icon="cog"
						allowedCapacities={[
							CAPACITIES.INTEGRATIONS.READ,
							CAPACITIES.INTEGRATIONS.MANAGE
						]}
					>
						<Trans i18nKey="access.menus.settings" />
					</NavMenuItem>
					<NavMenuBody>
						<NavMenuItem
							to={`${path}/exploitation/integrations`}
							allowedCapacities={[
								CAPACITIES.INTEGRATIONS.READ,
								CAPACITIES.INTEGRATIONS.MANAGE
							]}
						>
							{t("access.menus.integrations")}
						</NavMenuItem>
					</NavMenuBody>
				</NavMenu>
			</Menu>
			{!isLevelEvent && <SolutionControlMenu path={path} />}
		</>
	);
}

MenuOrga.propTypes = {
	organizationId: PropTypes.number.isRequired,
	isLevelEvent: PropTypes.bool.isRequired
};
